define(
    'providers/dataprovider.subscription',[
        "services/config"
    ],
    function (config) {
        var isTest = false;
        var testSubsMaxUserCount = 999;
        var testIsCardAdded = 1;
        var testInstanceStatusID = 7; //7 is suspended... 1 is active... 5 is trial
        
        //try { isTest = sessionStorage.getItem("__istest") == "1"; } catch (ex) { isTest = false; }
        
        function isCustomerTrial() {
            if (isTest) {
                var d = $.Deferred();

                setTimeout(function () {
                    d.resolve({ isTrial: testSubsMaxUserCount == 999 }, 200);
                }, 2000);

                return d.promise();
            }

            if (!isTest) {
                return $.Deferred(function (deferred) {
                    amplify.request({
                        resourceId: "get-subscription-iscustomertrial",
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                }).promise();
            }
        }

        function getOrCreateSessionPortal(data) {
            if (isTest) {
                var d = $.Deferred();

                setTimeout(function () {
                    d.resolve({ accessUrl: 'http://www.google.com' }, 200);
                }, 2000);

                return d.promise();
            }

            if (!isTest) {                
                return $.Deferred(function (deferred) {
                    amplify.request({
                        resourceId: "pos-subscription-getorcreatesessionportal",
                        data: data,
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                }).promise();
            }
    	}

    	function logoutSessionPortal(data) {
    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "pos-subscription-logoutsessionportal",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
    	}

    	function checkoutSubscription(data) {
    	    return $.Deferred(function (deferred) {
    	        amplify.request({
    	            resourceId: "pos-subscription-checkoutSubscription",
    	            data: data,
    	            success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    	            error: function (result, statusCode) { deferred.reject(result, statusCode); }
    	        });
    	    }).promise();
    	}

    	function cancelSubscription() {
    	    return $.Deferred(function (deferred) {
    	        amplify.request({
    	            resourceId: "get-subscription-cancelsubscription",
    	            success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    	            error: function (result, statusCode) { deferred.reject(result, statusCode); }
    	        });
    	    }).promise();
    	}

    	function reactivateSubscription(data) {
    	    if (isTest) {
    	        var d = $.Deferred();

    	        setTimeout(function () {
    	            d.resolve({}, 200);
    	        }, 2000);

    	        return d.promise();
    	    }

    	    if (!isTest) {
    	        return $.Deferred(function (deferred) {
    	            amplify.request({
    	                resourceId: "pos-subscription-reactivateSubscription",
    	                data: data,
    	                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    	                error: function (result, statusCode) { deferred.reject(result, statusCode); }
    	            });
    	        }).promise();
    	    }
    	}

    	function updateSubscription(data) {
    	    return $.Deferred(function (deferred) {
    	        amplify.request({
    	            resourceId: "pos-subscription-updateSubscription",
    	            data: data,
    	            success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    	            error: function (result, statusCode) { deferred.reject(result, statusCode); }
    	        });
    	    }).promise();
    	}

    	function getCustomerSubs() {
    	    if (isTest) {
    	        var d = $.Deferred();

    	        setTimeout(function () {
    	            d.resolve({
    	                instanceStatusID: testInstanceStatusID,
    	                isCardAdded: testIsCardAdded,
    	                subsMaxStorageLimit: 100,
    	                subsMaxUserCount: testSubsMaxUserCount
    	            }, 200);
    	        }, 2000);

    	        return d.promise();
    	    }

    	    if (!isTest) {
    	        return $.Deferred(function (deferred) {
    	            amplify.request({
    	                resourceId: "get-subscription-getcustomersubs",
    	                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    	                error: function (result, statusCode) { deferred.reject(result, statusCode); }
    	            });
    	        }).promise();
    	    }
    	}

    	init();

    	return {
    	    isCustomerTrial: isCustomerTrial,
    	    getOrCreateSessionPortal: getOrCreateSessionPortal,    	    
    	    logoutSessionPortal: logoutSessionPortal,
    	    checkoutSubscription: checkoutSubscription,
    	    cancelSubscription: cancelSubscription,
    	    getCustomerSubs: getCustomerSubs,
    	    updateSubscription: updateSubscription,
    	    reactivateSubscription: reactivateSubscription
    	};

    	function init() {
    		//#region subscription define

    	    amplify.request.define("get-subscription-iscustomertrial", "ajax", {
    	        url: getUrl("admin/fpoc/iscustomertrial"),
    	        dataType: "json",
    	        type: "GET"
    	    });

    		amplify.request.define("pos-subscription-getorcreatesessionportal", "ajax", {
    		    url: getUrl("admin/fpoc/portalsession/create"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "POST",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			},
    		});

    		amplify.request.define("pos-subscription-logoutsessionportal", "ajax", {
    		    url: getUrl("admin/fpoc/portalsession/logout"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "POST",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			},
    		});

    		amplify.request.define("pos-subscription-checkoutSubscription", "ajax", {
    		    url: getUrl("admin/fpoc/checkoutsubscription"),
    		    contentType: "application/json",
    		    dataType: "json",
    		    type: "POST",
    		    dataMap: function (data) {
    		        return JSON.stringify(data);
    		    },
    		});

    		amplify.request.define("get-subscription-cancelsubscription", "ajax", {
    		    url: getUrl("admin/fpoc/cancelsubscription"),
    		    dataType: "json",
    		    type: "POST"
    		});

    		amplify.request.define("get-subscription-getcustomersubs", "ajax", {
    		    url: getUrl("admin/fpoc/subscription"),
    		    dataType: "json",
    		    type: "GET"
    		});

    		amplify.request.define("pos-subscription-updateSubscription", "ajax", {
    		    url: getUrl("admin/fpoc/updatesubscription"),
    		    contentType: "application/json",
    		    dataType: "json",
    		    type: "POST",
    		    dataMap: function (data) {
    		        return JSON.stringify(data);
    		    },
    		});

    		amplify.request.define("pos-subscription-reactivateSubscription", "ajax", {
    		    url: getUrl("admin/fpoc/reactivatesubscription"),
    		    contentType: "application/json",
    		    dataType: "json",
    		    type: "POST",
    		    dataMap: function (data) {
    		        return JSON.stringify(data);
    		    },
    		});
    		
    		//#endregion
    	}

    	function getUrl(action) {
    		return config.webApiUrl + action;
    	}
    }
);
